/**
 * Step0DealType — Phase 27.
 *
 * Old "Step 1" — full-page deal-type picker. Verbatim JSX from the original
 * DealWizard.jsx (renderStep step === 1 branch). The picker requires the
 * user to ACTIVELY confirm with Continue; a pre-highlighted "last used"
 * option does not auto-advance.
 *
 * Preserve as-is: the lastUsedDealType seed is read-only (never auto-confirms).
 */
import DealTypePicker from "@/components/deal/DealTypePicker";

export default function Step0DealType({ wizard }) {
  return (
    <DealTypePicker
      value={wizard.pendingDealType}
      suggestedFromStorage={wizard.lastUsedDealType}
      onSelect={wizard.setPendingDealType}
      onConfirm={wizard.confirmDealType}
    />
  );
}
